import React from 'react';

const Backend = () => {
    return (
        <div className="skills__content">
        <h3 className="skills__title">Backend Developer</h3>

        <div className="skills__box">
            <div className="skills__group">
                
                <div className="skills__data">
                    <i class='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">Java</h3>
                        <span className='skills__level'>Advance</span>
                    </div>
                </div>

                
                <div className="skills__data">
                    <i class='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">Spring Boot</h3>
                        <span className='skills__level'>Intermediate</span>
                    </div>
                </div>

                
                <div className="skills__data">
                    <i class='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">MySQL</h3>
                        <span className='skills__level'>Intermediate</span>
                    </div>
                </div>
            </div>

            <div className="skills__group">
                
                <div className="skills__data">
                    <i class='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">Cloud</h3>
                        <span className='skills__level'>Intermediate</span>
                    </div>
                </div>

                
                <div className="skills__data">
                    <i class='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">Firebase</h3>
                        <span className='skills__level'>Advance</span>
                    </div>
                </div>

                
                <div className="skills__data">
                    <i class='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">System Design</h3>
                        <span className='skills__level'>Basic</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default Backend